import { useContext } from "react";
import { Context } from "../../../context/Context";
import { getCampaignText } from "./campaignActionsText";
import StatusBadge from "./StatusBadge";
import "./CampaignActions.css";

const formatDate = (value, lang) =>
  value ? new Date(value).toLocaleDateString(lang === "ar" ? "ar-SA" : "en-GB", { timeZone: "UTC" }) : "";

// One row per restaurant request with the status exactly as Operations holds
// it. rows: [{ key, store, status, startDate, endDate, error }]; `renderExtra`
// adds per-row actions.
export default function RequestStatusList({ rows, renderExtra }) {
  const { lang } = useContext(Context);
  const text = getCampaignText(lang);
  return (
    <ul className="ca-request-list">
      {rows.map((row) => {
        const dates =
          row.startDate || row.endDate
            ? (formatDate(row.startDate, lang) || "—") + " → " + (formatDate(row.endDate, lang) || "—")
            : text.noDates;
        return (
          <li key={row.key} className="ca-request-row">
            <span className="ca-request-store">{row.store}</span>
            {row.status && <StatusBadge status={row.status} />}
            <span className="ca-multi-hint" dir="ltr">
              {dates}
            </span>
            {renderExtra?.(row)}
            {row.error && (
              <span className="ca-request-error" role="alert">
                {row.error}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
}
